import * as Sentry from "@sentry/browser";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { createRoot } from "react-dom/client";
import App from "./App";

dayjs.extend(utc);

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENV || "development",
    release: import.meta.env.VITE_CI_COMMIT_SHORT_SHA,
    beforeSend(event) {
      const errorMessage = event?.exception?.values?.[0]?.value;
      const ignoredMessages = [
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications.",
        "TypeError: NetworkError when attempting to fetch resource.",
        "Socket closed with event 1011 keepalive ping timeout",
        "Failed to fetch",
        "Invalid Token",
        "Load failed",
        "Not allowed",
      ];

      if (ignoredMessages.some(msg => errorMessage?.includes(msg))) {
        return null;
      }
      return event;
    },
  });
}

const hashElement = document.getElementById("hash");

if (hashElement) {
  hashElement.innerText = import.meta.env.VITE_CI_COMMIT_SHORT_SHA || "";
}

Sentry.setTag("CI_COMMIT_SHORT_SHA", import.meta.env.VITE_CI_COMMIT_SHORT_SHA);

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(<App />);
